import { createAsyncThunk } from "@reduxjs/toolkit";
import Api from "../../Config/ApiConfig";
import { toast } from "react-toastify";

// Get user email history
export const getUserEmailHistory = createAsyncThunk(
  "emailHistory/getUserEmailHistory",
  async ({ userId, page = 1, limit = 10 }) => {
    try {
      const response = await Api.get(`user/${userId}/emails`, {
        params: { page, limit }
      });
      if (response.data.status_code === 200) {
        return response.data;
      } else {
        toast.error(response.data.message);
        throw new Error(response.data.message);
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      toast.error(errorMessage);
      throw new Error(errorMessage);
    }
  }
);

// Get email details
export const getEmailDetails = createAsyncThunk(
  "emailHistory/getEmailDetails",
  async (emailId) => {
    try {
      const response = await Api.get(`email/${emailId}`);
      if (response.data.status_code === 200) {
        return response.data.data;
      } else {
        toast.error(response.data.message);
        throw new Error(response.data.message);
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      toast.error(errorMessage);
      throw new Error(errorMessage);
    }
  }
);

// Get user email statistics
export const getUserEmailStats = createAsyncThunk(
  "emailHistory/getUserEmailStats",
  async (userId) => {
    try {
      const response = await Api.get(`user/${userId}/emails/stats`);
      if (response.data.status_code === 200) {
        return response.data.data;
      } else {
        toast.error(response.data.message);
        throw new Error(response.data.message);
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      toast.error(errorMessage);
      throw new Error(errorMessage);
    }
  }
);

// Get email history by category
export const getEmailHistoryByCategory = createAsyncThunk(
  "emailHistory/getEmailHistoryByCategory",
  async ({ userId, category, page = 1, limit = 10 }) => {
    try {
      const response = await Api.get(`user/${userId}/emails/category/${category}`, {
        params: { page, limit }
      });
      if (response.data.status_code === 200) {
        return response.data;
      } else {
        toast.error(response.data.message);
        throw new Error(response.data.message);
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      toast.error(errorMessage);
      throw new Error(errorMessage);
    }
  }
);

// Send custom email
export const sendCustomEmail = createAsyncThunk(
  "emailHistory/sendCustomEmail",
  async ({ userId, emailData }) => {
    try {
      const response = await Api.post(`user/${userId}/send-email`, emailData);
      if (response.data.status_code === 200) {
        toast.success("Custom email sent successfully");
        return response.data.data;
      } else {
        toast.error(response.data.message);
        throw new Error(response.data.message);
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      toast.error(errorMessage);
      throw new Error(errorMessage);
    }
  }
);

// Get email categories
export const getEmailCategories = createAsyncThunk(
  "emailHistory/getEmailCategories",
  async () => {
    try {
      const response = await Api.get("emails/categories");
      if (response.data.status_code === 200) {
        return response.data.data;
      } else {
        toast.error(response.data.message);
        throw new Error(response.data.message);
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      toast.error(errorMessage);
      throw new Error(errorMessage);
    }
  }
);